import React from 'react';
//import {NavLink} from 'react-router-dom';
import closeThin from '../../assets/close_thin.svg';
//import logoText from '../../assets/108_leonard_text.svg';
// import ProgressiveImg from "./ProgressiveImg";
import placeholderSrc from '../../images/108leonard-popup-thumb.jpeg'
import image from '../../images/108leonard-popup-full.jpeg'
import '../../styles/Popup.css';
import { withRouter } from "react-router-dom";

console.log(image, placeholderSrc)

const Popup = (props) => {
  const redirect = () => {
    props.closePopup();
    props.history.push('/films');
  }
  const handleLocalHrefClick = (event) => {
    event.preventDefault();
    props.closePopup();
    props.history.push('/contact');
  }
  return (
    <div className="popup">
      <div className="popup-background" onClick={props.closePopup}></div>

      <div className="popup-container">
        <button className="close-popup" onClick={props.closePopup}><img src={closeThin} alt="close popup icon"/></button>
        
        <div className="popup-content">
          
          <svg
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            viewBox="0 12.078 266.99999 23.208"
            enableBackground="new 0 12.078 530.635 23.208"
            className="popup-title">
            <defs
            id="defs25" 
            />
            
            <path
              d="M 13.405246,34.965575 H 8.8302462 v -17.131 l -5.2339996,2.599 v -4.576 l 6.8449994,-3.368 h 2.965 z m 8.844,-11.238 c 0,-6.846 3.587,-11.604 8.858,-11.604 5.271,0 8.858,4.758 8.858,11.604 0,6.845 -3.587,11.604 -8.858,11.604 -5.271,0 -8.858,-4.759 -8.858,-11.604 z m 4.575,0 c 0,4.173 1.245,7.431 4.283,7.431 3.001,0 4.283,-3.258 4.283,-7.431 0,-4.173 -1.282,-7.431 -4.283,-7.431 -3.038,0 -4.283,3.259 -4.283,7.431 z m 20.751,5.088 c 0,-2.855 1.794,-4.795 3.917,-5.381 -1.867,-0.806 -3.221,-2.599 -3.221,-4.978 0,-4.1 3.441,-6.333 7.395,-6.333 3.917,0 7.357,2.232 7.357,6.333 0,2.379 -1.354,4.173 -3.221,4.978 2.123,0.586 3.917,2.525 3.917,5.381 0,4.1 -3.587,6.516 -8.053,6.516 -4.503,0 -8.091,-2.416 -8.091,-6.516 z m 11.641,-0.366 c 0,-2.014 -1.538,-3.185 -3.551,-3.185 -2.05,0 -3.587,1.171 -3.587,3.185 0,1.978 1.538,3.187 3.587,3.187 2.013,-0.003 3.551,-1.212 3.551,-3.187 z m -0.513,-9.81 c 0,-1.829 -1.391,-2.891 -3.039,-2.891 -1.684,0 -3.074,1.061 -3.074,2.891 0,1.757 1.391,2.818 3.074,2.818 1.648,0 3.039,-1.061 3.039,-2.818 z m 27.710004,-6.15 h 4.685 v 18.34 h 10.46901 v 4.137 H 86.41225 Z m 38.45301,0 v 4.1 h -10.652 v 4.906 h 9.665 v 3.989 h -9.665 v 5.345 h 10.652 v 4.137 h -15.264 v -22.477 z m 18.256,22.842 c -6.259,0 -10.616,-4.904 -10.616,-11.604 0,-6.735 4.357,-11.604 10.616,-11.604 6.259,0 10.651,4.868 10.651,11.604 0,6.697 -4.392,11.604 -10.651,11.604 z m 0,-19.035 c -3.552,0 -5.855,3.039 -5.855,7.431 0,4.395 2.305,7.431 5.855,7.431 3.587,0 5.931,-3.036 5.931,-7.431 -0.003,-4.392 -2.344,-7.431 -5.931,-7.431 z m 38.164,18.669 h -3.696 l -10.615,-14.972 v 14.972 h -4.502 v -22.476 h 4.393 l 9.92,14.203 v -14.203 h 4.502 z m 20.993,-22.476 8.604,22.477 h -4.76 l -2.014,-5.418 h -8.419 l -1.978,5.418 h -4.686 l 8.604,-22.477 z m -5.125,13.105 h 5.491 l -2.745,-7.468 z m 26.118,0.989 v 8.383 h -4.648 v -22.477 h 9.261 c 4.723,0 7.871,2.527 7.871,7.139 0,3.586 -1.978,5.855 -5.125,6.625 l 5.93,8.713 h -5.271 l -5.564,-8.383 z m 0,-3.845 h 4.319 c 2.343,0 3.551,-1.244 3.551,-3.111 0,-1.905 -1.208,-3.149 -3.551,-3.149 h -4.319 z m 21.289,-10.249 h 7.942 c 6.811,0 11.092,4.393 11.092,11.238 0,6.845 -4.281,11.238 -11.092,11.238 h -7.942 z m 7.76,18.34 c 4.283,0 6.627,-2.746 6.627,-7.102 0,-4.393 -2.344,-7.137 -6.627,-7.137 h -3.11 v 14.239 z"
              id="path18" />

          </svg>
          <p className="sans popup-subtitle">A remarkable way to live</p>
          <p className="serif">We are proud to reveal our newly completed<br />amenities.</p>
          <p className="serif">Immediate Occupancy</p>
          <p className="serif">To schedule a private tour please call us at:<br /><a onClick={props.closePopup} href='tel:212-775-1080'>212.775.1080</a> OR <a onClick={handleLocalHrefClick} href='/contact'>Contact Us</a></p>
          
        </div>
        <div className="popup-media">
          <a className='cta-films sans'  onClick={redirect}>Visit our films page</a>
          <iframe
            title='title'
            src={`https://player.vimeo.com/video/864250143?h=a5c7c8907&title=0&byline=0&portrait=0&autoplay=1&muted=1`}
            frameBorder='0'
            allow='autoplay; fullscreen; picture-in-picture'
            allowFullScreen
            autoPlay
          ></iframe>

        </div>
      </div>
      
      
    </div>
  );
};

export default withRouter(Popup);


// WEBPACK FOOTER //
// ./src/components/partials/Popup.js